"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectSearchTournaments = exports.selectTournamentsLoading = exports.selectSearchPageSportIds = exports.selectSearchPageQuery = exports.selectMainSearchDataEntries = exports.selectFetchMainItemsError = exports.selectSearchPageFilters = void 0;
const getSearchProviderState = (state) => {
    return state.searchProviderV2;
};
const selectMainSearchData = (state) => {
    return getSearchProviderState(state).main;
};
const selectSearchPageData = (state) => {
    return getSearchProviderState(state).searchPage;
};
const selectSearchPageFilters = (state) => {
    return selectSearchPageData(state).filters;
};
exports.selectSearchPageFilters = selectSearchPageFilters;
const selectSearchPageTournamentsData = (state) => {
    return selectSearchPageData(state).tournaments;
};
const selectFetchMainItemsError = (state) => {
    return selectMainSearchData(state).fetchItems.error;
};
exports.selectFetchMainItemsError = selectFetchMainItemsError;
const selectMainSearchDataEntries = (state) => {
    return selectMainSearchData(state).entries;
};
exports.selectMainSearchDataEntries = selectMainSearchDataEntries;
const selectSearchPageQuery = (state) => {
    return (0, exports.selectSearchPageFilters)(state).searchQuery;
};
exports.selectSearchPageQuery = selectSearchPageQuery;
const selectSearchPageSportIds = (state) => {
    return (0, exports.selectSearchPageFilters)(state).sportIds;
};
exports.selectSearchPageSportIds = selectSearchPageSportIds;
const selectTournamentsLoading = (state) => {
    return selectSearchPageTournamentsData(state).fetchItems.loading;
};
exports.selectTournamentsLoading = selectTournamentsLoading;
const selectSearchTournaments = (state) => {
    return selectSearchPageTournamentsData(state).entries;
};
exports.selectSearchTournaments = selectSearchTournaments;
//# sourceMappingURL=selectors.js.map